import { render, staticRenderFns } from "./AddApparatusUpgradeFromLegacy.vue?vue&type=template&id=2ba4df66"
import script from "./AddApparatusUpgradeFromLegacy.vue?vue&type=script&lang=js"
export * from "./AddApparatusUpgradeFromLegacy.vue?vue&type=script&lang=js"
import style0 from "./AddApparatusUpgradeFromLegacy.vue?vue&type=style&index=0&id=2ba4df66&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Generac.Application.MobileLink\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ba4df66')) {
      api.createRecord('2ba4df66', component.options)
    } else {
      api.reload('2ba4df66', component.options)
    }
    module.hot.accept("./AddApparatusUpgradeFromLegacy.vue?vue&type=template&id=2ba4df66", function () {
      api.rerender('2ba4df66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Enrollment/Subscription/AddApparatusUpgradeFromLegacy.vue"
export default component.exports